import clsx from 'clsx'

type SnapCounterBadgeProps = {
    count: number
    className?: string
}

export default function SnapCounterBadge({ count, className }: SnapCounterBadgeProps) {
    return (
        <div
            className={clsx(
                'pointer-events-none relative shrink-0',
                'size-6',
                'stele:size-24',
                className,
            )}
            aria-hidden
        >
            <div className='absolute top-1/2 left-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-green-gradient stele:size-24' />
            <p
                className={clsx(
                    'absolute left-1/2 top-1.5 -translate-x-1/2 rotate-[-20deg]',
                    'font-grandstander text-base font-black italic leading-none tracking-wide text-green-stroke uppercase',
                    'stele:top-6 stele:text-6xl stele:tracking-wide',
                )}
            >
                {count}
            </p>
            <div
                className={clsx(
                    'absolute top-0 right-0 size-6 rounded-full',
                    'border-2 border-green-stroke shadow-[0_2px_0_0_var(--color-green-stroke)]',
                    'stele:size-24 stele:border-4 stele:shadow-[0_8px_0_0_var(--color-green-stroke)]',
                )}
            />
        </div>
    )
}
